import { Copy, Download, X } from 'lucide-react'
import { copyToClipboard, downloadFile } from '../utils/helpers'
import { useState } from 'react'

interface LLMTxtPreviewProps {
  content: string
  onClose: () => void
  onDownload: () => void
}

export function LLMTxtPreview({ content, onClose, onDownload }: LLMTxtPreviewProps) {
  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    const success = await copyToClipboard(content)
    if (success) {
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    }
  }

  const handleDownload = () => {
    downloadFile(content, 'llm.txt', 'text/plain')
    onDownload()
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl shadow-2xl max-w-4xl w-full max-h-[90vh] flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h2 className="text-2xl font-semibold text-gray-900">llm.txt Preview</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors duration-200"
          >
            <X className="h-6 w-6" />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-hidden flex flex-col">
          <div className="p-6 flex-1 overflow-y-auto">
            <div className="bg-gray-50 rounded-lg p-4 border">
              <pre className="whitespace-pre-wrap text-sm text-gray-800 font-mono leading-relaxed">
                {content}
              </pre>
            </div>
          </div>

          {/* Actions */}
          <div className="p-6 border-t border-gray-200 bg-gray-50">
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={handleCopy}
                className="btn-outline flex items-center justify-center"
              >
                <Copy className="h-4 w-4 mr-2" />
                {copied ? 'Copied!' : 'Copy to Clipboard'}
              </button>
              
              <button
                onClick={handleDownload}
                className="btn-primary flex items-center justify-center"
              >
                <Download className="h-4 w-4 mr-2" />
                Download llm.txt
              </button>
            </div>

            <div className="mt-4 text-center">
              <p className="text-sm text-gray-600">
                Save this file as <code className="bg-gray-200 px-2 py-1 rounded text-xs">llm.txt</code> in your website's root directory.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
